import { render, staticRenderFns } from "./MarketPlaceSettingsDetail.vue?vue&type=template&id=27f4e43a&scoped=true&"
import script from "./MarketPlaceSettingsDetail.vue?vue&type=script&lang=js&"
export * from "./MarketPlaceSettingsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4e43a",
  null
  
)

export default component.exports